import { DATE_REGEX } from './formatting';

// Get the date representing 18 before today (Pacific Time)
export function getMaxDateOfBirthByMinAge(minAge: number): Date {
  const current = new Date().toLocaleString('en-us', {
    timeZone: 'America/Los_Angeles',
  });
  const currentDate = new Date(current);
  return new Date(
    currentDate.getFullYear() - minAge,
    currentDate.getMonth(),
    currentDate.getDate()
  );
}

// Validate current value.dateOfBirth string represents a valid date
export function validateDate(userDateOfBirthString?: string): boolean {
  // Return false when the date string is empty or incomplete
  if (!userDateOfBirthString) return false;
  if (userDateOfBirthString.length < 10) return false;
  // Cast date string as Date and check if it is a valid Date
  const userDateOfBirth = new Date(userDateOfBirthString);
  if (userDateOfBirth.valueOf() !== userDateOfBirth.getTime()) return false;
  // Test against date regex when the date string represents a valid Date
  return DATE_REGEX.test(userDateOfBirthString);
}

// Validate current value.dateOfBirth is after 01/01/1900
export function validateMaxAgeOrYounger(
  userDateOfBirthString?: string
): boolean {
  if (!userDateOfBirthString) return false;
  // the oldest birthday allowed is Jan 1st 1900 😭
  const minBirthDate = new Date(1900, 0, 1);
  const userDateOfBirth = new Date(userDateOfBirthString);
  return userDateOfBirth >= minBirthDate;
}

// Validate current value.dateOfBirth for maximum date of birth (18 years before now)
export function validateMinAgeOrOlder(
  minAge: number,
  userDateOfBirthString?: string
): boolean {
  if (!userDateOfBirthString) return false;
  const maxBirthDate = getMaxDateOfBirthByMinAge(minAge);
  const userDateOfBirth = new Date(userDateOfBirthString);
  return userDateOfBirth <= maxBirthDate;
}
